var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHuman01 = function SvgHuman01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient);\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 21.79,
    y1: 178.76,
    x2: 160.7,
    y2: 51.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 49.11,
    y1: 208.54,
    x2: 188.03,
    y2: 81.06,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M99.7,98.46c13.1-7.5,22.04-21.45,22.04-37.59,0-23.97-19.5-43.48-43.48-43.48s-43.48,19.5-43.48,43.48c0,16.14,8.95,30.1,22.04,37.59C24.07,107.06,0,134.76,0,167.58v10.68c0,2.4,1.95,4.35,4.35,4.35s4.35-1.95,4.35-4.35v-10.68c0-34.86,31.21-63.23,69.56-63.23s69.57,28.37,69.57,63.23v10.68c0,2.4,1.95,4.35,4.35,4.35s4.35-1.95,4.35-4.35v-10.68c0-32.83-24.07-60.53-56.83-69.12ZM43.48,60.87c0-19.18,15.6-34.78,34.78-34.78s34.78,15.6,34.78,34.78-15.6,34.78-34.78,34.78-34.78-15.6-34.78-34.78Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M158.24,98.57c9.43-6.23,15.67-16.9,15.67-29.01,0-19.18-15.6-34.78-34.78-34.78-2.4,0-4.35,1.95-4.35,4.35s1.95,4.35,4.35,4.35c14.38,0,26.09,11.7,26.09,26.09s-11.7,26.09-26.09,26.09c-2.4,0-4.35,1.95-4.35,4.35s1.95,4.35,4.35,4.35c28.77,0,52.17,21.63,52.17,48.22v8.3c0,2.4,1.95,4.35,4.35,4.35s4.35-1.95,4.35-4.35v-8.3c0-25.13-17.53-46.48-41.76-53.99Z"
  })));
};
export default SvgHuman01;